import { useEffect, useState } from 'react'
import { NavLink, Outlet, useLocation } from 'react-router'
import { useAuth } from '../lib/auth'
import { APP_NAME } from '../lib/supabase'

const NAV: { to: string; label: string; adminOnly?: boolean }[] = [
  { to: '/', label: 'Inicio' },
  { to: '/descargar-app', label: 'Descargar la app' },
  { to: '/carreras', label: 'Carreras' },
  { to: '/conductores', label: 'Conductores' },
  { to: '/pasajeros', label: 'Pasajeros' },
  { to: '/finanzas', label: 'Comisiones y liquidaciones' },
  { to: '/tarifas', label: 'Tarifas', adminOnly: true },
  { to: '/lugares', label: 'Lugares frecuentes' },
  { to: '/areas', label: 'Áreas de servicio', adminOnly: true },
  { to: '/soporte', label: 'Soporte e incidencias' },
  { to: '/informes', label: 'Informes' },
  { to: '/configuracion', label: 'Configuración', adminOnly: true },
  { to: '/auditoria', label: 'Auditoría', adminOnly: true },
]

export function Layout() {
  const { name, isAdmin, roles, signOut } = useAuth()
  const [open, setOpen] = useState(false)
  const loc = useLocation()
  useEffect(() => setOpen(false), [loc.pathname])
  const [online, setOnline] = useState(navigator.onLine)
  useEffect(() => {
    const on = () => setOnline(true)
    const off = () => setOnline(false)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => {
      window.removeEventListener('online', on)
      window.removeEventListener('offline', off)
    }
  }, [])

  return (
    <div className="shell">
      <aside className={`sidebar ${open ? 'open' : ''}`}>
        <div className="brand">
          <img src="/favicon.svg" alt="" width={32} height={32} />
          <div>
            <strong>{APP_NAME}</strong>
            <small>Panel administrativo</small>
          </div>
        </div>
        <nav aria-label="Secciones">
          {NAV.filter((n) => !n.adminOnly || isAdmin).map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === '/'} className={({ isActive }) => (isActive ? 'active' : '')}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-foot">
          <div className="who">
            <strong>{name}</strong>
            <small>{roles.filter((r) => r === 'admin' || r === 'support').map((r) => (r === 'admin' ? 'Administrador' : 'Soporte')).join(', ')}</small>
          </div>
          <button className="btn btn-ghost btn-light" onClick={() => void signOut()}>Cerrar sesión</button>
        </div>
      </aside>
      <div className="main">
        <header className="topbar">
          <button className="icon-btn menu-btn" onClick={() => setOpen((o) => !o)} aria-label="Abrir menú">☰</button>
          <span className="topbar-title">{APP_NAME}</span>
        </header>
        {!online ? <div className="offline-banner" role="status">Sin conexión a internet. Los datos pueden estar desactualizados.</div> : null}
        <main className="content">
          <Outlet />
        </main>
      </div>
      {open ? <div className="scrim" onClick={() => setOpen(false)} /> : null}
    </div>
  )
}
